module.exports = __webpack_public_path__ + "static/media/unmute.d54225cb.svg";